import * as React from 'react';
import { capitaliseFirstLetter } from '../../utils';
import * as styles from './Box.module.css';

export const Box = React.forwardRef(function Box(
  {
    children,
    className = '',
    display = 'block',
    element = 'div',
    height = 'auto',
    padding = 'none',
    style = {},
    width = 'auto',
    ...rest
  },
  ref,
) {
  const Component = element;
  const paddingClass = `padding${capitaliseFirstLetter(padding)}`;
  
  const combinedClasses = [styles.box, styles[paddingClass], className]
    .filter(Boolean)
    .join(' ');
  
  const combinedStyles = {
    '--display': display,
    '--width': width,
    '--height': height,
    ...style,
  };  

  return (
    <Component
      className={combinedClasses}
      ref={ref}
      style={combinedStyles}
      {...rest}
    >
      {children}
    </Component>
  );
});
